import Type from '../type';
import aliases from './aliases';
import registry from './registry';

import { type GlobalEventMap } from './global-event-map';

function bind<K extends keyof GlobalEventMap>(
	target: EventTarget,
	eventName: K,
	listener: (event: GlobalEventMap[K]) => void,
	options?: boolean | AddEventListenerOptions,
): void;

function bind(
	target: EventTarget,
	eventName: string,
	handler: EventListenerOrEventListenerObject | null,
	options?: AddEventListenerOptions | boolean,
): void;

function bind(
	target: EventTarget,
	eventName: string,
	handler: EventListenerOrEventListenerObject | null,
	options?: AddEventListenerOptions | boolean,
): void
{
	if (!Type.isEventTargetLike(target) || handler === null)
	{
		return;
	}

	if (eventName in aliases)
	{
		aliases[eventName].forEach((key) => {
			target.addEventListener(key, handler, options);
			registry.set(target, eventName, handler);
		});

		return;
	}

	target.addEventListener(eventName, handler, options);
	registry.set(target, eventName, handler);
}

export default bind;
